import { createContext, useContext } from 'react';

interface IAiReportContext {
	onPhotoIndexClick?: (index: number) => void;
}

export const AiReportContext = createContext<IAiReportContext>({});

export const useAiReportContext = () => useContext(AiReportContext);
